var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutionCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 497,
    height: 497,
    viewBox: "0 0 497 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 248.5,
    cy: 248.5,
    r: 248.5,
    fill: "#0B3192",
    fillOpacity: 0.04
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.5,
    cy: 248.5,
    r: 247.926,
    stroke: "#0B3192",
    strokeOpacity: 0.14,
    strokeWidth: 1.14701
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.5,
    cy: 248.5,
    r: 197.141,
    fill: "#0B3192",
    fillOpacity: 0.04
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.5,
    cy: 248.5,
    r: 196.567,
    stroke: "#0B3192",
    strokeOpacity: 0.14,
    strokeWidth: 1.14701
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.5,
    cy: 248.5,
    r: 145.781,
    fill: "#0B3192",
    fillOpacity: 0.04
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.5,
    cy: 248.5,
    r: 145.208,
    stroke: "#0B3192",
    strokeOpacity: 0.14,
    strokeWidth: 1.14701
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionCircles);
export default __webpack_public_path__ + "static/media/solutionCircles.bdbf06b88f37d227d6e333dbd18ceef6.svg";
export { ForwardRef as ReactComponent };